var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 18 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 11C2.66421 11 3 11.3358 3 11.75V14.75C3 14.9489 3.07902 15.1397 3.21967 15.2803C3.36032 15.421 3.55109 15.5 3.75 15.5H14.25C14.4489 15.5 14.6397 15.421 14.7803 15.2803C14.921 15.1397 15 14.9489 15 14.75V11.75C15 11.3358 15.3358 11 15.75 11C16.1642 11 16.5 11.3358 16.5 11.75V14.75C16.5 15.3467 16.2629 15.919 15.841 16.341C15.419 16.7629 14.8467 17 14.25 17H3.75C3.15326 17 2.58097 16.7629 2.15901 16.341C1.73705 15.919 1.5 15.3467 1.5 14.75V11.75C1.5 11.3358 1.83579 11 2.25 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71967 7.46967C5.01256 7.17678 5.48744 7.17678 5.78033 7.46967L9 10.6893L12.2197 7.46967C12.5126 7.17678 12.9874 7.17678 13.2803 7.46967C13.5732 7.76256 13.5732 8.23744 13.2803 8.53033L9.53033 12.2803C9.23744 12.5732 8.76256 12.5732 8.46967 12.2803L4.71967 8.53033C4.42678 8.23744 4.42678 7.76256 4.71967 7.46967Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C9.41421 2 9.75 2.33579 9.75 2.75V11.75C9.75 12.1642 9.41421 12.5 9 12.5C8.58579 12.5 8.25 12.1642 8.25 11.75V2.75C8.25 2.33579 8.58579 2 9 2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e4e8341fa261123825fdd46ed993c66c.svg";
export { ForwardRef as ReactComponent };